import {Field} from 'formik';


import {
    FormikSelect,
    FormikSwitch,
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Stack} from "@mantine/core";
import {CustomersAutocomplete} from "../../customers/inputs/CustomersAutocomplete.tsx";


export const FormComponent = () => {

    return (
        <Stack gap={'xl'}>

            <PlatformFieldset legend={'Indent Details'} variant={'filled'}>

                <Field
                    name='amount'
                    label='Amount'
                    description='Please enter the amount'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='currency'
                    label='Currency'
                    description='Please enter currency'
                    component={FormikSelect}
                    data={[
                        {
                            value: 'usd',
                            label: 'USD'
                        },
                        {
                            value: 'eur',
                            label: 'EUR'
                        },
                    ]}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='description'
                    label='Description'
                    description='Please enter custome description'
                    component={FormikTextarea}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='customerId'
                    label='Customer'
                    description='Please enter customer'
                    component={CustomersAutocomplete}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='automaticPaymentMethods.enabled'
                    label='Automatic Payment Methods Is Enabled'
                    description='Please enable or disable automatic payment methods'
                    component={FormikSwitch}
                    data={[
                        {
                            value: 'true',
                            label: 'Enabled'
                        },
                        {
                            value: 'false',
                            label: 'Disabled'
                        },
                    ]}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='setupFutureUsage'
                    label='Setup Future Usage'
                    description='Please enter setup future usage'
                    component={FormikSelect}
                    data={[
                        {
                            value: 'offSession',
                            label: 'Off Session'
                        },
                        {
                            value: 'onSession',
                            label: 'On Session'
                        },
                    ]}
                    withAsterisk
                    my={'xl'}
                />


            </PlatformFieldset>

        </Stack>
    );
};
